import FederatedSignupMessage from './FederatedSignupMessage'
export default FederatedSignupMessage
